import { queryAll } from "../../../../../scripts/src/utils.js";
import { MaskedButton } from "../../../../../scripts/src/modules/mask-button";

class PreFooterCTA extends HTMLDivElement {
	maskBtns;
	constructor() {
		super();
	}

	get childrenLoaded() {
		if (this._childrenLoaded) {
			return this._childrenLoaded;
		} else {
			if (!this._childrenLoadedPromise) {
				this._childrenLoadedPromise = new Promise((resolve, reject) => {
					const observer = new MutationObserver(() => {
						if (this?.lastChild?.isConnected) {
							this._childrenLoaded = true;
							observer.disconnect();
							resolve(true);
						}
					});
					observer.observe(this, {
						childList: true,
						subtree: true,
					});
				});
			}
			return this._childrenLoadedPromise;
		}
	}

	async connectedCallback() {
		await this.childrenLoaded;
		this.maskBtns = [...queryAll(".mask-btn", this)];

		this.maskBtns.forEach((el) => {
			if (!el.instance) el.instance = new MaskedButton(el);
		});
	}
}

customElements.define("pre-footer-cta", PreFooterCTA, { extends: "div" });
